/**
 * Mensagem de erro de uma ação de deal (Ganho / Perda / mover).
 *
 * O backend (kanban_controller) devolve `{ error: '...' }` com o motivo REAL —
 * "Conversa não está neste funil", "Informe um valor final válido", falta de
 * permissão etc. Os handlers mostravam só um genérico "Tente novamente" e a
 * causa ficava invisível (foi o que mascarou o bug do funil errado no Ganho).
 *
 * @param {Object} error - erro do axios
 * @param {string} fallback - texto genérico quando não há mensagem do backend
 * @returns {string}
 */
export function dealActionErrorMessage(error, fallback) {
  const backendMessage = error?.response?.data?.error;
  return typeof backendMessage === 'string' && backendMessage.trim()
    ? backendMessage
    : fallback;
}
